import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import brand from "../assets/images/brand_name.jpg";
import './ourservices.css';

const Ourservices = () =>{
    useEffect(() => {
        Aos.init({ duration: 500, offset: 150 });
    });
    
        return (
            <div id="our-services" className="our-services-container my-5">
                <div className="container mt-5">
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-10 text-white text-center">
                            <h1 style={{fontSize: "3rem"}} className="fw-bolder" data-aos="zoom-in">Our Services</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1">
                            <div className="p-2 mt-4 rounded-5 game-card" data-aos="flip-up">
                                <div className="m-2 rounded-5 card-bg">
                                    <img className="card-image" src={brand} alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Brand Name Suggestion
                                </div>
                                <div className="col-md-12 mt-1 col-12 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="p-2 mt-4 rounded-5 game-card" data-aos="flip-up" >
                                <div className="m-2 rounded-5 card-bg">
                                    <img className="card-image" src="https://cdn.pixabay.com/photo/2015/05/19/07/44/browser-773215_1280.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Logo Design
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="mt-4 p-2 rounded-5 game-card" data-aos="flip-up" >
                                <div className="m-2 rounded-5 card-bg" >
                                    <img className="card-image" src="https://cdn.pixabay.com/photo/2017/01/16/15/10/box-1984281_1280.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Packaging Design
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="mt-4 p-2 rounded-5 game-card" data-aos="flip-up" >
                                <div className="m-2 rounded-5 card-bg" >
                                    <img className="card-image" src="https://cdn.pixabay.com/photo/2022/07/23/05/05/computer-7339324_1280.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Digital Marketing
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="mt-4 p-2 rounded-5 game-card" data-aos="flip-up">
                                <div className="m-2 rounded-5 card-bg">
                                    <img className="card-image" src="https://cdn.pixabay.com/photo/2024/05/02/09/16/web-development-8734249_1280.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Web Development
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="mt-4 p-2 rounded-5 game-card" data-aos="flip-up">
                                <div className="m-2 rounded-5 card-bg" >
                                    <img className="rounded-5 card-image" src="https://cdn.pixabay.com/photo/2016/07/27/18/18/cinema-1545942_1280.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Content Creation
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="mt-4 p-2 rounded-5 game-card" data-aos="flip-up" >
                                <div className="m-2 rounded-5 card-bg" >
                                    <img className="card-image" src="https://cdn.pixabay.com/photo/2013/07/12/15/40/television-150304_1280.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Offline Marketing
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-12 d-flex justify-content-center px-1 ">
                            <div className="mt-4 p-2 rounded-5 game-card" data-aos="flip-up" >
                                <div className="m-2 rounded-5 card-bg" >
                                    <img className="card-image" src="https://images.fineartamerica.com/images/artworkimages/medium/3/time-to-level-up-8th-grade-kids-video-game-theme-party-print-art-grabitees-transparent.png" alt="brand">
                                    </img>
                                </div>
                                <div className="col-md-12 col-12 p-1 fw-bolder fs-4 text-center">
                                    Games
                                </div>
                                <div className="col-md-12 col-12 mt-1 text-center">
                                    <a href="#vr-game" className="know-more-link border p-2 text-decoration-none rounded-3 fw-bold fs-6">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
}

export default Ourservices;